// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';


class EditTournamentSubscription extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      subscription: {
        "id": props.match.params.id,
        "amount_paid": props.match.params.amount_paid,
        },
      data_uploaded: false,
      data_error: false,
      venues: [],
      game_type: []
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
  }

  postEditedSubscription(data, props) {
    const url = `${getLocationOrigin()}/eagleeye/edit_tournament_subscription/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'subscription': data});
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one = Object.assign({}, this.state.subscription);
    new_selected_one[name] = event.target.value
    this.setState({subscription: new_selected_one});
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postEditedSubscription(this.state.subscription, this.props);
  }

  render() {
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Edit Subscription</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Amount Paid
              </div>
              <input type="number"
                style={styles.input}
                name="amount_paid"
                value={this.state.subscription.amount_paid}
                onChange={this.handleChange}/>
            </div>

            <div style={styles.button_submit} className="col-md-12">
              <input className="btn btn-lg" type="submit" value="Submit" style={{backgroundColor:'#302C35',
                color:'#ffffff'}}/>
            </div>
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default EditTournamentSubscription;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editTournamentSubscription/index.js